/* ORIOM Shop — behaviour. Same universe as www.oriom.space, plus cart. */
(function () {
  "use strict";
  var CFG = window.ORIOM_SHOP || { cartUrl: "/cart", cartAddUrl: "/cart/add", root: "/" };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* ---------- scroll bus ---------- */
  var scrollers = [], ticking = false;
  function onScroll(fn) { scrollers.push(fn); }
  function runScroll() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset, vh = window.innerHeight;
    for (var i = 0; i < scrollers.length; i++) scrollers[i](y, vh);
  }
  window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }, { passive: true });
  window.addEventListener("resize", runScroll);

  function visibleLoop(el, draw) {
    var on = false, raf = 0;
    function frame(t) { draw(t); raf = requestAnimationFrame(frame); }
    function start() { if (!on) { on = true; raf = requestAnimationFrame(frame); } }
    function stop() { on = false; cancelAnimationFrame(raf); }
    if (reduce) { draw(1200); return { redraw: function () { draw(1200); } }; }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { rootMargin: "120px" }).observe(el);
    } else start();
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); });
    return { redraw: function () { draw(performance.now()); } };
  }

  /* ---------- header + menu ---------- */
  var header = $(".site-header");
  if (header) onScroll(function (y) { header.classList.toggle("is-solid", y > 24); });
  var toggle = $(".nav-toggle");
  if (toggle) {
    var label = $(".nav-toggle__label", toggle);
    var setOpen = function (open) {
      document.documentElement.classList.toggle("nav-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (label) label.textContent = open ? "Close" : "Menu";
    };
    toggle.addEventListener("click", function () { setOpen(!document.documentElement.classList.contains("nav-open")); });
    $$(".nav a").forEach(function (a) { a.addEventListener("click", function () { setOpen(false); }); });
  }

  /* ---------- starfield ---------- */
  function cosmos() {
    var c = $(".cosmos");
    if (!c || !c.getContext) return;
    var ctx = c.getContext("2d"), w = 0, h = 0, dpr = 1, scrollY = window.scrollY || 0, rnd = mulberry(7);
    var layers = [
      { n: 240, depth: .06, r: [.35, .75], a: [.22, .55] },
      { n: 110, depth: .18, r: [.6, 1.05], a: [.35, .75] },
      { n: 34, depth: .42, r: [1, 1.75], a: [.55, .95] }
    ];
    var stars = [];
    layers.forEach(function (L) {
      for (var i = 0; i < L.n; i++) stars.push({ x: rnd(), y: rnd(), d: L.depth, r: lerp(L.r[0], L.r[1], rnd()), a: lerp(L.a[0], L.a[1], rnd()), p: rnd() * 6.28, s: .4 + rnd() * 1.4, warm: rnd() < .7 });
    });
    var clouds = [0, 1, 2].map(function (k) {
      var oc = document.createElement("canvas"); oc.width = 720; oc.height = 460;
      var o = oc.getContext("2d");
      for (var i = 0; i < 2600; i++) {
        var gx = gauss(rnd) * .22, gy = gauss(rnd) * .2;
        o.fillStyle = "rgba(244,208,78," + (.1 + rnd() * .35).toFixed(2) + ")";
        o.beginPath(); o.arc(360 + (gx + gy * .6) * 720, 230 + gy * 460, rnd() < .92 ? .55 + rnd() * .5 : 1 + rnd() * .9, 0, 6.283); o.fill();
      }
      return { img: oc, x: [.82, .08, .7][k], y: [.18, 1.25, 2.4][k], d: .12, rot: [-.5, .4, -.2][k] };
    });
    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2); w = window.innerWidth; h = window.innerHeight;
      c.width = Math.round(w * dpr); c.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function draw(t) {
      ctx.clearRect(0, 0, w, h);
      var span = h * 1.6, k, i;
      for (k = 0; k < clouds.length; k++) {
        var cl = clouds[k], cy = cl.y * h - scrollY * cl.d * (reduce ? 0 : 1);
        cy = ((cy % (h * 3)) + h * 3) % (h * 3) - h * .6;
        ctx.save(); ctx.globalAlpha = .55; ctx.translate(cl.x * w, cy); ctx.rotate(cl.rot);
        var s = Math.max(w, 700) / 1100; ctx.drawImage(cl.img, -360 * s, -230 * s, 720 * s, 460 * s); ctx.restore();
      }
      for (i = 0; i < stars.length; i++) {
        var st = stars[i], y = st.y * span - scrollY * st.d * (reduce ? 0 : 1);
        y = ((y % span) + span) % span - (span - h) / 2;
        if (y < -4 || y > h + 4) continue;
        ctx.globalAlpha = st.a * (reduce ? 1 : .72 + .28 * Math.sin(t * .001 * st.s + st.p));
        ctx.fillStyle = st.warm ? "#f4d04e" : "#fff0c8";
        if (st.r < .9) ctx.fillRect(st.x * w, y, st.r * 1.6, st.r * 1.6);
        else { ctx.beginPath(); ctx.arc(st.x * w, y, st.r, 0, 6.283); ctx.fill(); }
      }
      ctx.globalAlpha = 1;
    }
    size();
    window.addEventListener("resize", function () { size(); draw(performance.now()); });
    onScroll(function (y) { scrollY = y; if (reduce) draw(0); });
    if (reduce) { draw(0); return; }
    var last = 0, raf = 0;
    function frame(t) { if (t - last > 33) { last = t; draw(t); } raf = requestAnimationFrame(frame); }
    raf = requestAnimationFrame(frame);
    document.addEventListener("visibilitychange", function () { cancelAnimationFrame(raf); if (!document.hidden) raf = requestAnimationFrame(frame); });
  }

  /* ---------- dotted halo (shop intro, 404, password page) ---------- */
  function halo() {
    $$("[data-halo]").forEach(function (cv) {
      var ctx = cv.getContext("2d"), N = 0, dpr = 1, progress = 0, off = document.createElement("canvas");
      function build() {
        dpr = Math.min(window.devicePixelRatio || 1, 2); N = Math.round(cv.clientWidth);
        cv.width = off.width = Math.round(N * dpr); cv.height = off.height = Math.round(N * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var o = off.getContext("2d"), rnd = mulberry(3), c = N / 2, R = N * .34;
        o.setTransform(dpr, 0, 0, dpr, 0, 0);
        for (var i = 0; i < 3400; i++) {
          var a = rnd() * 6.283, g = gauss(rnd);
          var dr = g < 0 ? g * N * .006 : Math.pow(g, 1.6) * N * .022;
          var size = Math.max(.5, (1.9 - Math.abs(dr) / (N * .02)) * (.55 + rnd() * .55)) * N / 900;
          o.fillStyle = "rgba(244,208,78," + (dr > N * .02 ? .35 + rnd() * .3 : .6 + rnd() * .4).toFixed(2) + ")";
          o.beginPath(); o.arc(c + Math.cos(a) * (R + dr), c + Math.sin(a) * (R + dr), size, 0, 6.283); o.fill();
        }
      }
      function draw(t) {
        if (!N) return;
        ctx.clearRect(0, 0, N, N); ctx.save(); ctx.translate(N / 2, N / 2);
        ctx.rotate(t * .00003 + progress * .9);
        var s = 1 + progress * .22; ctx.scale(s, s); ctx.globalAlpha = 1 - progress * .6;
        ctx.drawImage(off, -N / 2, -N / 2, N, N); ctx.restore();
      }
      build();
      var loop = visibleLoop(cv, draw);
      window.addEventListener("resize", function () { build(); loop.redraw(); });
      onScroll(function (y, vh) { progress = clamp(y / vh, 0, 1); });
    });
  }

  /* ---------- cart ---------- */
  var toastEl = $(".toast"), toastTimer = 0;
  function toast(text, withLink) {
    if (!toastEl) return;
    toastEl.textContent = text;
    if (withLink) {
      var a = document.createElement("a"); a.href = CFG.cartUrl; a.textContent = "View cart";
      toastEl.appendChild(a);
    }
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4200);
  }
  function setCount(n) { $$("[data-cart-count]").forEach(function (el) { el.textContent = n; }); }

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains("js-add") || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'), old = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding …"; }
    fetch(CFG.cartAddUrl + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || "This item could not be added.");
        return fetch(CFG.cartUrl + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        toast("Added to your cart.", true);
        if (btn) { btn.textContent = "Added"; setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1600); }
      })
      .catch(function (err) {
        toast(err.message || "This item could not be added. Please try again.");
        if (btn) { btn.textContent = old; btn.disabled = false; }
      });
  });

  /* ---------- product page: variants and images ---------- */
  var select = $("[data-variant-select]");
  if (select) {
    var priceEl = $("[data-price]"), addBtn = $("[data-add-button]");
    select.addEventListener("change", function () {
      var o = select.options[select.selectedIndex];
      if (priceEl) {
        priceEl.textContent = "";
        if (o.getAttribute("data-compare")) { var s = document.createElement("s"); s.textContent = o.getAttribute("data-compare"); priceEl.appendChild(s); }
        priceEl.appendChild(document.createTextNode(o.getAttribute("data-price")));
      }
      var available = o.getAttribute("data-available") === "true";
      if (addBtn) { addBtn.disabled = !available; addBtn.textContent = available ? "Add to cart" : "Sold out"; }
      if (o.getAttribute("data-image")) showImage(o.getAttribute("data-image"));
      if (window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set("variant", o.value); history.replaceState(null, "", u);
      }
    });
  }
  function showImage(src) {
    var img = $(".product__main img");
    if (!img) return;
    img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = src;
  }
  $$("[data-thumb]").forEach(function (b) {
    b.addEventListener("click", function () {
      showImage(b.getAttribute("data-thumb"));
      $$("[data-thumb]").forEach(function (x) { x.removeAttribute("aria-current"); });
      b.setAttribute("aria-current", "true");
    });
  });

  /* ---------- utilities ---------- */
  function mulberry(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function gauss(r) { var u = 1 - r(), v = r(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(6.283 * v); }

  cosmos(); halo(); runScroll();
})();
